module.exports = __webpack_public_path__ + "static/media/banner.db88da43.png";